// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.miniCalendarTable_kVj20 {
	border-spacing: 3px;
	z-index: 400000;
}

.miniCalendarTbody_o6QSU {
	gap: 3px;
}

.miniCalendarTr_e4FMH {
	border-bottom: 2px solid var(--_16c0982e-background);
}
.miniCalendarTr_e4FMH:last-child {
	border-bottom: none !important;
}
.miniCalendarTd_CG3LB {
	position: relative;
	border: 2px solid var(--_16c0982e-background) !important;
}
.miniCalendarTd_CG3LB:first-child {
	border-left: none !important;
}
.miniCalendarTd_CG3LB:last-child {
	border-right: none !important;
}
.bottomMiniCalendarTd_g3kWF {
	border: none !important;
	border-right: 2px solid var(--_16c0982e-background) !important;
	border-left: 2px solid var(--_16c0982e-background) !important;
}
.bottomMiniCalendarTd_g3kWF:first-child {
	border-left: none !important;
}
.bottomMiniCalendarTd_g3kWF:last-child {
	border-right: none !important;
}
.miniCalendarTh_Ymfn5 {
	border: 2px solid var(--_16c0982e-background);
	border-top: none;
}
.miniCalendarTh_Ymfn5:first-child {
	border-left: none;
}
.miniCalendarTh_Ymfn5:last-child {
	border-right: none;
}
.dayCell_SPFYT {
	border-radius: 50%;
	color: var(--_3c3a3a-color);
	cursor: pointer;
	width: 25px !important;
	height: 25px !important;
	min-width: 25px !important;
	min-height: 25px !important;
	-webkit-user-select: none;
	        user-select: none;
	padding: 3px !important;
	display: flex;
	align-items: center;
	margin-left: 5px;
	justify-content: center;
	font-size: 12px;
	&:hover {
		background: var(--label-color);
	}
}

.selectedDayCell_PsSAd {
	background: var(--_16c0982e-background);
	border-radius: 50%;
	cursor: pointer;
	color: var(--_16c098-background);
	width: 25px !important;
	height: 25px !important;
	min-width: 25px !important;
	min-height: 25px !important;
	padding: 3px !important;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 12px;
	&:hover {
		background: var(--_16c098-color);
	}
}

.currentDayCell_qJUhE {
	background: var(--_16c098-background);
	border-radius: 50%;
	color: var(--white-color);
	cursor: pointer;
	width: 25px !important;
	height: 25px !important;
	min-width: 25px !important;
	min-height: 25px !important;
	padding: 3px !important;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 12px;
	&:hover {
		background: var(--_16c098-background);
	}
}
.eventDotsContainer_bUfym {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	flex-direction: row;
	position: absolute;
	top: 1px;
	right: 1px;
}
.eventDot_otN_8 {
	width: 10px;
	margin-left: -3px;
	display: flex;
	align-items: center;
	justify-content: center;
	padding-top: 1px;
	font-size: 7px;
	color: var(--white-color);
	height: 10px;
	border-radius: 50%;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/CalendarView/Calendar/components/WatchCalendar/CustomAppointmentCalendar/CustomAppointmentCalendar.module.css"],"names":[],"mappings":"AAAA;CACC,mBAAmB;CACnB,eAAe;AAChB;;AAEA;CACC,QAAQ;AACT;;AAEA;CACC,oDAAoD;AACrD;AACA;CACC,8BAA8B;AAC/B;AACA;CACC,kBAAkB;CAClB,wDAAwD;AACzD;AACA;CACC,4BAA4B;AAC7B;AACA;CACC,6BAA6B;AAC9B;AACA;CACC,uBAAuB;CACvB,8DAA8D;CAC9D,6DAA6D;AAC9D;AACA;CACC,4BAA4B;AAC7B;AACA;CACC,6BAA6B;AAC9B;AACA;CACC,6CAA6C;CAC7C,gBAAgB;AACjB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,2BAA2B;CAC3B,eAAe;CACf,sBAAsB;CACtB,uBAAuB;CACvB,0BAA0B;CAC1B,2BAA2B;CAC3B,yBAAiB;SAAjB,iBAAiB;CACjB,uBAAuB;CACvB,aAAa;CACb,mBAAmB;CACnB,gBAAgB;CAChB,uBAAuB;CACvB,eAAe;CACf;EACC,8BAA8B;CAC/B;AACD;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,eAAe;CACf,gCAAgC;CAChC,sBAAsB;CACtB,uBAAuB;CACvB,0BAA0B;CAC1B,2BAA2B;CAC3B,uBAAuB;CACvB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,eAAe;CACf;EACC,gCAAgC;CACjC;AACD;;AAEA;CACC,qCAAqC;CACrC,kBAAkB;CAClB,yBAAyB;CACzB,eAAe;CACf,sBAAsB;CACtB,uBAAuB;CACvB,0BAA0B;CAC1B,2BAA2B;CAC3B,uBAAuB;CACvB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,eAAe;CACf;EACC,qCAAqC;CACtC;AACD;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,2BAA2B;CAC3B,mBAAmB;CACnB,kBAAkB;CAClB,QAAQ;CACR,UAAU;AACX;AACA;CACC,WAAW;CACX,iBAAiB;CACjB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,gBAAgB;CAChB,cAAc;CACd,yBAAyB;CACzB,YAAY;CACZ,kBAAkB;AACnB","sourcesContent":[".miniCalendarTable {\n\tborder-spacing: 3px;\n\tz-index: 400000;\n}\n\n.miniCalendarTbody {\n\tgap: 3px;\n}\n\n.miniCalendarTr {\n\tborder-bottom: 2px solid var(--_16c0982e-background);\n}\n.miniCalendarTr:last-child {\n\tborder-bottom: none !important;\n}\n.miniCalendarTd {\n\tposition: relative;\n\tborder: 2px solid var(--_16c0982e-background) !important;\n}\n.miniCalendarTd:first-child {\n\tborder-left: none !important;\n}\n.miniCalendarTd:last-child {\n\tborder-right: none !important;\n}\n.bottomMiniCalendarTd {\n\tborder: none !important;\n\tborder-right: 2px solid var(--_16c0982e-background) !important;\n\tborder-left: 2px solid var(--_16c0982e-background) !important;\n}\n.bottomMiniCalendarTd:first-child {\n\tborder-left: none !important;\n}\n.bottomMiniCalendarTd:last-child {\n\tborder-right: none !important;\n}\n.miniCalendarTh {\n\tborder: 2px solid var(--_16c0982e-background);\n\tborder-top: none;\n}\n.miniCalendarTh:first-child {\n\tborder-left: none;\n}\n.miniCalendarTh:last-child {\n\tborder-right: none;\n}\n.dayCell {\n\tborder-radius: 50%;\n\tcolor: var(--_3c3a3a-color);\n\tcursor: pointer;\n\twidth: 25px !important;\n\theight: 25px !important;\n\tmin-width: 25px !important;\n\tmin-height: 25px !important;\n\tuser-select: none;\n\tpadding: 3px !important;\n\tdisplay: flex;\n\talign-items: center;\n\tmargin-left: 5px;\n\tjustify-content: center;\n\tfont-size: 12px;\n\t&:hover {\n\t\tbackground: var(--label-color);\n\t}\n}\n\n.selectedDayCell {\n\tbackground: var(--_16c0982e-background);\n\tborder-radius: 50%;\n\tcursor: pointer;\n\tcolor: var(--_16c098-background);\n\twidth: 25px !important;\n\theight: 25px !important;\n\tmin-width: 25px !important;\n\tmin-height: 25px !important;\n\tpadding: 3px !important;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-size: 12px;\n\t&:hover {\n\t\tbackground: var(--_16c098-color);\n\t}\n}\n\n.currentDayCell {\n\tbackground: var(--_16c098-background);\n\tborder-radius: 50%;\n\tcolor: var(--white-color);\n\tcursor: pointer;\n\twidth: 25px !important;\n\theight: 25px !important;\n\tmin-width: 25px !important;\n\tmin-height: 25px !important;\n\tpadding: 3px !important;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-size: 12px;\n\t&:hover {\n\t\tbackground: var(--_16c098-background);\n\t}\n}\n.eventDotsContainer {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tflex-direction: row;\n\tposition: absolute;\n\ttop: 1px;\n\tright: 1px;\n}\n.eventDot {\n\twidth: 10px;\n\tmargin-left: -3px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tpadding-top: 1px;\n\tfont-size: 7px;\n\tcolor: var(--white-color);\n\theight: 10px;\n\tborder-radius: 50%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"miniCalendarTable": `miniCalendarTable_kVj20`,
	"miniCalendarTbody": `miniCalendarTbody_o6QSU`,
	"miniCalendarTr": `miniCalendarTr_e4FMH`,
	"miniCalendarTd": `miniCalendarTd_CG3LB`,
	"bottomMiniCalendarTd": `bottomMiniCalendarTd_g3kWF`,
	"miniCalendarTh": `miniCalendarTh_Ymfn5`,
	"dayCell": `dayCell_SPFYT`,
	"selectedDayCell": `selectedDayCell_PsSAd`,
	"currentDayCell": `currentDayCell_qJUhE`,
	"eventDotsContainer": `eventDotsContainer_bUfym`,
	"eventDot": `eventDot_otN_8`
};
export default ___CSS_LOADER_EXPORT___;
